var _a;
import { GEMINI_USAGE_CATEGORIES, GeminiAppNameEnum, GeminiUsageCategoryEnum, GeminiUsageLevelEnum } from '@workalizer/shared/enums';
import { distributeSharePercentages, getPercentageDiff, randomInt, toPercent } from '@workalizer/shared/utils';
var CATEGORY_ACTION_RANGES = (_a = {},
    _a[GeminiUsageCategoryEnum.CHAT_AND_RESEARCH] = [520, 700],
    _a[GeminiUsageCategoryEnum.CONTENT_CREATION] = [260, 380],
    _a[GeminiUsageCategoryEnum.SUMMARIZE] = [380, 520],
    _a[GeminiUsageCategoryEnum.WORKFLOW_ACTIONS] = [80, 160],
    _a);
var aroundCount = function (count, spread) {
    if (spread === void 0) { spread = 0.2; }
    return randomInt(Math.round(count * (1 - spread)), Math.round(count * (1 + spread)));
};
export var geminiUserSummary = function (_input) {
    var counts = GEMINI_USAGE_CATEGORIES.map(function (category) {
        return randomInt.apply(void 0, CATEGORY_ACTION_RANGES[category]);
    });
    var totalActions = counts.reduce(function (sum, count) { return sum + count; }, 0);
    var shares = distributeSharePercentages(counts);
    var standaloneShare = randomInt(20, 32);
    var standaloneActions = Math.round((totalActions * standaloneShare) / 100);
    var previousStandaloneShare = randomInt(20, 32);
    var teamStandaloneShare = randomInt(20, 32);
    var topAppActions = Math.round((totalActions - standaloneActions) * (randomInt(50, 70) / 100));
    var categories = GEMINI_USAGE_CATEGORIES.reduce(function (acc, category, index) {
        var count = counts[index];
        acc[category] = {
            count: count,
            share: shares[index],
            prevPeriodDiff: getPercentageDiff(aroundCount(count), count),
            teamAvgDiff: getPercentageDiff(aroundCount(count, 0.3), count)
        };
        return acc;
    }, {});
    return {
        totalActions: {
            count: totalActions,
            prevPeriodDiff: getPercentageDiff(aroundCount(totalActions), totalActions),
            teamAvgDiff: getPercentageDiff(aroundCount(totalActions, 0.3), totalActions)
        },
        standaloneInAppUsage: {
            left: {
                share: standaloneShare,
                count: standaloneActions,
                prevPeriodDiff: getPercentageDiff(previousStandaloneShare, standaloneShare),
                teamAvgDiff: getPercentageDiff(teamStandaloneShare, standaloneShare)
            },
            right: {
                share: 100 - standaloneShare,
                count: totalActions - standaloneActions,
                prevPeriodDiff: getPercentageDiff(100 - previousStandaloneShare, 100 - standaloneShare),
                teamAvgDiff: getPercentageDiff(100 - teamStandaloneShare, 100 - standaloneShare)
            }
        },
        categories: categories,
        topApp: {
            appName: GeminiAppNameEnum.DRIVE,
            count: topAppActions,
            share: toPercent(topAppActions, totalActions),
            prevPeriodDiff: getPercentageDiff(aroundCount(topAppActions), topAppActions),
            teamAvgDiff: getPercentageDiff(aroundCount(topAppActions, 0.3), topAppActions)
        },
        usageLevel: {
            period: {
                isValid: true,
                weekCount: 12,
                effectiveDateFrom: '2026-01-01',
                effectiveDateTo: '2026-03-25'
            },
            level: GeminiUsageLevelEnum.HIGH,
            previousLevel: GeminiUsageLevelEnum.MEDIUM,
            previous: getPercentageDiff(2, 3)
        }
    };
};
